import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { zabbixApi, type ZabbixMetrics } from '@/api/zabbix'

export type { ZabbixMetrics, ZabbixHost, ZabbixProblem, ZabbixSummary } from '@/api/zabbix'

export function useZabbixMetrics(tenantId: number | string) {
  const queryClient = useQueryClient()
  const id = typeof tenantId === 'string' ? Number(tenantId) : tenantId
  const queryKey = ['zabbix-metrics', id]

  const query = useQuery<ZabbixMetrics>({
    queryKey,
    queryFn: () => zabbixApi.getMetrics(id),
    enabled: !!id,
    refetchInterval: 300_000,
    staleTime: 300_000,
  })

  const refreshMutation = useMutation({
    mutationFn: () => zabbixApi.refresh(id),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, data)
    },
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isStale: query.data?.is_stale ?? false,
    refresh: () => refreshMutation.mutate(),
    isRefreshing: refreshMutation.isPending,
  }
}
